import { t } from '@lingui/core/macro';
import { BooleanFilter } from './BooleanFilter';
export const deviateFromStandardFilterLabel = () => t({ message: 'Deviate from standard', comment: 'Insights: Deviate From Standard filter' });
export function DeviateFromStandardFilter() {
    return <BooleanFilter name="metadataDocumentDeviateFromStandard" label={deviateFromStandardFilterLabel()}/>;
}
